// "AT17.CL_CROP.717" => "717"
export function parseCodeFromId(id) {
  return id.split('.')[2];
}

// "AT17.FOI.3513176" => "AT17"
export function parseScopeFromId(id) {
  return id.split('.')[0];
}

// "AT17" => "2017"
export function parseFullYearFromScope(yearCode) {
  return '20' + yearCode.slice(-2);
}
